import {
  DispatcherAuthPrefix,
  DispatcherCategoryService,
  DispatcherResource
} from 'modules/types/common';
import { CacheTypes } from 'modules/types/mobileCaching';
import { getDispatcherUrl } from 'modules/utils/UrlUtils';
import { patientEducationRequestStateSelector } from './selectors';

// Education List Actions
export const GET_LIST_CACHE_SUCCESS = 'EDUCATION.GET_LIST_CACHE_SUCCESS';
export const GET_LIST = 'EDUCATION.GET_LIST';
export const GET_LIST_SUCCESS = 'EDUCATION.GET_LIST_SUCCESS';
export const GET_LIST_FAIL = 'EDUCATION.GET_LIST_FAIL';
export const getEducationList = (useRequestState = true) => ({
  type: GET_LIST,
  payload: {
    useRequestState,
    requestStateSelector: patientEducationRequestStateSelector,
    cacheType: CacheTypes.PATIENT_EDUCATION,
    cacheRetrievalSuccessAction: GET_LIST_CACHE_SUCCESS,
    client: 'dispatcher',
    request: {
      method: 'get',
      url: getDispatcherUrl(
        DispatcherCategoryService.HEALTH_RECORDS,
        DispatcherAuthPrefix.AUTHENTICATED,
        DispatcherResource.EDUCATION
      )
    }
  }
});
